import React, { useState, useEffect } from 'react'
import Loader from '../Loader/Loader'
import { getFilterAllCategories, deleteFilterCategory } from '../../Web Apis/Apis'
import { message, Pagination } from 'antd'
import { AiFillDelete, AiFillEdit, AiOutlineEye } from "react-icons/ai";
import CreateFilter from './CreateFilter';
import UpdateFilter from './UpdateFilter';

function FilterCategory() {
  const [loading, setLoading] = useState(false)
  const [action, setAction] = useState(false)
  const [allFilterCategories, setAllFilterCateories] = useState([])
  const [selectedCategory, setSelectedCategory] = useState({})

  const [showDeleteModalOpen, setShowDeleteModalOpen] = useState(false)
  const [showCreateModalOpen, setShowCreateModalOpen] = useState(false)
  const [showUpdateModalOpen, setShowUpdateModalOpen] = useState(false)

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(12);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Calculate the current items for the page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentCategories = allFilterCategories.slice(indexOfFirstItem, indexOfLastItem);


  const fetchAllFilterCategories = async () => {
    try {
      setLoading(true)

      const response = await getFilterAllCategories()

      if (response?.data?.success) {
        setAllFilterCateories(response?.data?.data)
      }

    } catch (error) {
      console.log("Error while fetch filtered category", error.message)
      if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert("Your account is logged in to another device, please login again !")
        localStorage.clear();
        window.location.href = "/login"
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding")
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchAllFilterCategories()
  }, [action])

  const hanldeDelete = async () => {
    try {
      setLoading(true)

      const response = await deleteFilterCategory(selectedCategory)
      if (response?.data?.success) {
        message.success(response?.data?.message)
        setShowDeleteModalOpen(false)
        setAction(!action)
      }
    } catch (error) {
      console.log("Error while deleting category", error.message)
      message.error(error?.response?.data?.message || "Error occured")
    } finally {
      setLoading(false)
    }
  }


  const handleCreateModalOpen = () => {
    setShowCreateModalOpen(true)
  }

  const handleUpdateModalOpen = (category) => {
    setSelectedCategory(category)
    setShowUpdateModalOpen(true)
  }

  const handleDeleteModalOpen = (category) => {
    setSelectedCategory(category)
    setShowDeleteModalOpen(true)
  }

  return (
    <div className='p-4'>
      <div className='flex justify-between'>
        <h3 className='text-3xl font-bold'>Filter Category Management</h3>
        {/* <div className='flex justify-end'>
          <button
            onClick={handleCreateModalOpen}
            className="bg-gradient-to-br from-blue-500 to-gray-500 hover:bg-blue-700 text-white font-bold py-2 px-8 rounded"
          >
            Create
          </button>
        </div> */}
      </div>

      <table className='min-w-full mt-7 bg-gradient-to-br from-purple-700 to-gray-300 border border-b-4 border-black'>
        <thead>
          <th className="py-2 px-4 border-b text-center">S.No</th>
          <th className="py-2 px-4 border-b text-center">Occasion Name</th>
          <th className="py-2 px-4 border-b text-center">Sub Categories</th>
          <th className="py-2 px-4 border-b text-center">Actions</th>
        </thead>
        <tbody>
          {currentCategories?.length > 0 ? (
            currentCategories?.map((category, index) => (
              <tr key={category.id}
                className={`hover:bg-gray-200 text-center transition duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-300'}`}
              >
               
                <td className='py-2 px-4 border-b'>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                <td className="py-2 px-4 border-b">{category?.category}</td>


                {/* Subcategory Dropdown */}
                <td className="py-2 px-4 border-b">
                  {category?.subcategory?.length > 0 ? (
                    <select className="border border-gray-800 rounded px-2 py-1 w-44">
                      {category?.subcategory?.map((sub) => (
                        <option key={sub.id} value={sub.subcategory}>
                          {sub.subcategory}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span>No Subcategories</span>
                  )}
                </td>

                  
                <td className="py-2 px-4 border-b ">
                  <div className="flex flex-row justify-center ">
                  {category?.category !== "Occasions" && category.category !== "Relationships" && (
                    <>
                    {/* <button
                                      onClick={() => handleViewModalOpen(category)}
                                      className="text-blue-500 hover:text-blue-700 flex items-center"
                                    >
                                      <AiOutlineEye className="mr-1 text-2xl" />
                                    </button> */}

                                    <button
                                    onClick={() => handleUpdateModalOpen(category)}
                                    className="mr-2 text-blue-500 hover:text-blue-700 flex items-center"
                                  >
                                    <AiFillEdit className="mr-1 text-2xl" />
                                  </button>
                                  <button
                                    onClick={() => handleDeleteModalOpen(category)}
                                    className="text-red-500 hover:text-red-700 flex items-center"
                                  >
                                    <AiFillDelete className="mr-1 text-2xl" />
                                  </button>
                                  </>
                  )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className=' px-4 py-4 border-b text-center font-bold'>No filter category data found</td>
            </tr>
          )

          }
        </tbody>
      </table>
      {loading && <Loader />}

      {showCreateModalOpen && (
        <CreateFilter
          showCreateModalOpen={showCreateModalOpen}
          setShowCreateModalOpen={setShowCreateModalOpen}
          action={action}
          setAction={setAction}
        />
      )}

      {showUpdateModalOpen && (
        <UpdateFilter
          showUpdateModalOpen={showUpdateModalOpen}
          setShowUpdateModalOpen={setShowUpdateModalOpen}
          action={action}
          setAction={setAction}
          selectedCategory={selectedCategory}
        />
      )}


      {showDeleteModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-gradient-to-br from-purple-900 to-purple-500 p-8 rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-3xl font-bold mb-4 text-start text-white">Confirm Delete</h3>
            <p className="mb-4 text-start text-white">Are you sure you want to delete this category ? </p>
            <div className="flex justify-end gap-4">
              <button onClick={() => { setShowDeleteModalOpen(false) }} className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200">
                Cancel
              </button>
              <button onClick={hanldeDelete} className="bg-red-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-red-700 transition duration-200">
                Delete
              </button>
            </div>
          </div>
        </div>
      )
      }

      {/* <div className="mt-4 flex justify-end">
        <Pagination
          current={currentPage}
          total={allFilterCategories.length}
          pageSize={itemsPerPage}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div> */}


    </div>
  )
}

export default FilterCategory